import { useState } from 'react';
import { ReceiptText } from 'lucide-react';
import { ColumnDef } from '@tanstack/react-table';
import { MeetingFormSubmission } from '@durma-soft/gros-sdk/dist/types/restaurants';

import { Modal } from '@/components/shared/modal';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/shared/shadcn-ui/tooltip';

import { TType } from '@/types/general';

export const columns = (t: TType): ColumnDef<MeetingFormSubmission>[] => [
  {
    accessorKey: 'name',
    header: t('common.name'),
  },
  {
    accessorKey: 'details',
    enableSorting: false,
    header: t('common.details'),
    cell: (cellData) => {
      console.log(cellData);
      // eslint-disable-next-line react-hooks/rules-of-hooks
      const [isOpen, setIsOpen] = useState(false);
      return (
        <>
          <TooltipProvider delayDuration={100}>
            <Tooltip>
              <TooltipTrigger asChild className="w-min">
                <div role="button" onClick={() => setIsOpen(true)}>
                  <ReceiptText className="w-5 h-5" />
                </div>
              </TooltipTrigger>
              <TooltipContent>{t('common.details')}</TooltipContent>
            </Tooltip>
          </TooltipProvider>
          <Modal
            isModalOpen={isOpen}
            closeModal={() => setIsOpen(false)}
            title={t('common.details')}
            className="overflow-hidden flex flex-col"
          >
            <ul className="flex flex-col gap-2 [&>li]:flex [&>li]:gap-2 [&>li]:items-center [&>li]:font-semibold [&>li>span]:font-normal">
              <li>
                {t('common.name')}: <span>{cellData.row.original.name}</span>
              </li>
              <li>
                {t('meetings.contact-person')}:{' '}
                <span>{cellData.row.original.contact_person}</span>
              </li>
              <li>
                {t('meetings.contact-phone')}:{' '}
                <span>{cellData.row.original.contact_phone}</span>
              </li>
              {cellData.row.original.contact_email && (
                <li>
                  {t('meetings.contact-email')}:{' '}
                  <span>{cellData.row.original.contact_email}</span>
                </li>
              )}
              {cellData.row.original.type === 'company' && (
                <li>
                  {t('meetings.number-of-employees')}:{' '}
                  <span>{cellData.row.original.number_of_employees}</span>
                </li>
              )}
              <li>
                {t('meetings.location')}:{' '}
                <span>{cellData.row.original.city}</span>
              </li>
              {cellData.row.original.message && (
                <li>
                  {t('meetings.additional-notes')}:{' '}
                  <span>{cellData.row.original.message}</span>
                </li>
              )}
            </ul>
          </Modal>
        </>
      );
    },
  },
];
